<template>
  <b-container>
    <b-row v-if="slugNotFound">
      <b-col>
        <h3>404 - Archiv Eintrag konnte nicht gefunden werden</h3>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12">
        <b-card>
          <b-media>
            <b-img slot="aside" :src="imageSrc" :alt="imageAlt"></b-img>
            <h6 v-if="item.kicker" class="text-muted">{{ item.kicker }}</h6>
            <h3>{{ item.headline }}</h3>
            <dl class="row">
              <dt class="col-sm-3">Datensatznummer:</dt>
              <dd class="col-sm-9">{{ item.id }}</dd>
              <dt class="col-sm-3">Medium:</dt>
              <dd class="col-sm-9">{{ item.object }} vom {{ date }}, Seite {{ item.page }} von {{ item.pageCount }}</dd>
              <dt class="col-sm-3">Autor:</dt>
              <dd class="col-sm-9">{{ item.author }}</dd>
              <dt class="col-sm-3">Thema:</dt>
              <dd class="col-sm-9">{{ item.topic }}</dd>
              <dt class="col-sm-3">Textsorte:</dt>
              <dd class="col-sm-9">{{ item.text }}</dd>
              <dt class="col-sm-3">Platzierung:</dt>
              <dd class="col-sm-9">{{ item.place }}</dd>
              <dt class="col-sm-3">Bebildert:</dt>
              <dd class="col-sm-9">{{ item.illustration }}</dd>
              <dt class="col-sm-3">Inhalt:</dt>
              <dd class="col-sm-9">{{ item.content }}</dd>
            </dl>

            <a target="_blank" :href="pdfDownloadurl">PDF-Download</a>
          </b-media>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { DateSmallDecorator } from '@/helper'
import store from '@/store'

export default {
  name: 'MediaDetailPage',
  created() {
    store.commit('setBreadcrumb', [ 'Medienarchiv' ])
    this.routeSlug = this.$route.params.slug
    this.itemIndex = this.$route.params.index

    if (this.itemIndex === undefined) {
      this.itemIndex = this.$store.getters.getIndexFromSlug(this.routeSlug)
    }
  },
  computed: {
    item: function () {
      return this.$store.getters.getItemFromResult(this.itemIndex)
    },
    slugNotFound: function () {
      return !this.item
    },
    pdfDownloadurl: function () {
      return '/dl/' + this.item.id + '/article.pdf'
    },
    imageSrc: function () {
      return '/dl/' + this.item.id + '/thumbnail.jpg'
    },
    imageAlt: function () {
      return this.item.object + ' vom ' + DateSmallDecorator(this.item.date)
    },
    date: function () {
      return DateSmallDecorator(this.item.date)
    }
  },
  methods: {
    DateSmallDecorator
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/MediaDetailPage.vue